import Vue from "vue"
const state = {
    API                 : 'https://api1.ufs.arizona.edu/api', 
    //API                 : 'http://localhost:44327',
}

export default {
    state
}